import unionIcon from "../../assets/icons/account-icon.svg";
import clinicalStudiesIcon from "../../assets/icons/clinical-studies-icon.svg";
import barcodeImage from "../../assets/images/barcode.png";
import barcodeLavenderImage from "../../assets/images/barcode-lavender.png";
import vhBarcodeImage from "../../assets/images/vh_gold_barcode.png";
import vhBarcodeLavenderImage from "../../assets/images/vh_lavender_barcode.png";
import magnifyingIcon from "../../assets/images/search-icon.svg";
import vhSearchIcon from "../../assets/icons/Search.svg";
import searchIcon from "../../assets/images/search.svg";
import { formatCost } from "../../utils/utils";
// ============================================
// REUSABLE FIELD GENERATORS
// ============================================

const createTextField = (overrides = {}) => ({
  type: "text",
  as: "",
  required: false,
  size: "text",
  readOnly: false,
  disabled: false,
  className: "form-group",
  showCalendarIcon: false,
  ...overrides,
});

const createPasswordField = (overrides = {}) => ({
  type: "password",
  as: "",
  required: true,
  size: "text",
  readOnly: false,
  disabled: false,
  className: "form-group",
  maxLength: 255,
  ...overrides,
});

const createEmailField = (overrides = {}) => ({
  type: "email",
  as: "",
  required: true,
  size: "text",
  readOnly: false,
  disabled: false,
  className: "form-group",
  maxLength: 255,
  ...overrides,
});

const createSelectField = (options, overrides = {}) => ({
  type: "select",
  options,
  as: "",
  required: true,
  size: "text",
  readOnly: false,
  disabled: false,
  ...overrides,
});

const createButtonField = (overrides = {}) => ({
  type: "button",
  required: false,
  ...overrides,
});

const createSubmitButton = (label, overrides = {}) => ({
  label,
  type: "submit",
  variant: "primary",
  ...overrides,
});

const createBarcodeField = ({
  name,
  placeholder,
  image,
  helpTextAbove,
  overrides = {},
}) => ({
  label: "",
  type: "text",
  name,
  placeholder,
  required: false,
  helpTextAbove,
  FormFieldImage: image,
  className: "form-group barcode-tubes",
  maxLength: 12,
  ...overrides,
});

const createDateField = (overrides = {}) => ({
  label: "Date",
  type: "date",
  name: "sample_collection_date",
  placeholder: "DD/MM/YYYY",
  readOnly: false,
  required: false,
  maxLength: 8,
  className: "barcode-date",
  ...overrides,
});

const createTimeField = (overrides = {}) => ({
  label: "Time",
  type: "time",
  name: "sample_collection_time",
  placeholder: "hh:mm",
  readOnly: false,
  required: false,
  ...overrides,
});

const createAttemptsField = (overrides = {}) => ({
  label: "No. of attempts",
  type: "select",
  name: "number_of_attempt",
  placeholder: "Select",
  options: ["1", "2"],
  readOnly: false,
  required: false,
  ...overrides,
});

const createNotesField = (overrides = {}) => ({
  label: "",
  placeholder: "Notes",
  as: "textarea",
  maxLength: 256,
  draggable: false,
  type: "notes",
  name: "notes",
  className: "notes-textarea",
  readOnly: false,
  required: false,
  ...overrides,
});

const createButtonGroup = (buttons) => ({
  btnGroup: buttons,
});

export const getCrioLabel = (isVhLogin = false) =>
  isVhLogin ? "Crio identifier (Optional)" : "Crio identifier (if available)";

// change request to have occupation phlebotomist by default

// ============================================
// COMMON FIELD DEFINITIONS
// ============================================

// const OCCUPATION_OPTIONS = [
//   "Clinician",
//   "Dentist",
//   "Dietitian",
//   "Doctor",
//   "Nurse",
//   "Nutritionist",
//   "Phlebotomist",
// ];

// const OCCUPATION_OPTIONS_WITH_VALUES = [
//   { value: "clinician", label: "Clinician" },
//   { value: "dentist", label: "Dentist" },
//   { value: "dietitian", label: "Dietitian" },
//   { value: "doctor", label: "Doctor" },
//   { value: "nurse", label: "Nurse" },
//   { value: "nutritionist", label: "Nutritionist" },
//   { value: "phlebotomist", label: "Phlebotomist" },
// ];

const OCCUPATION_OPTIONS = ["Phlebotomist"];

const OCCUPATION_OPTIONS_WITH_VALUES = [
  { value: "phlebotomist", label: "Phlebotomist" },
];

const commonPersonalFields = {
  firstName: (overrides = {}) =>
    createTextField({
      controlId: "1",
      label: "First name",
      name: "first_name",
      placeholder: "First name",
      required: true,
      maxLength: 63,
      colSize: 4,
      aria_describedby: "val1",
      ...overrides,
    }),

  lastName: (overrides = {}) =>
    createTextField({
      controlId: "2",
      label: "Last name",
      name: "last_name",
      placeholder: "Last name",
      required: true,
      maxLength: 63,
      colSize: 4,
      aria_describedby: "val2",
      ...overrides,
    }),

  occupation: (overrides = {}) =>
    createSelectField(OCCUPATION_OPTIONS, {
      controlId: "3",
      label: "Occupation",
      name: "occupation",
      colSize: 4,
      placeholder: "Choose occupation",
      aria_describedby: "val2",
      isdisabled: true,
      ...overrides,
    }),
  email: (overrides = {}) =>
    createEmailField({
      controlId: "7",
      label: "Email",
      name: "email",
      colSize: 4,
      placeholder: "Enter your email address",
      readOnly: true,
      aria_describedby: "val7",
      ...overrides,
    }),
  mobile: (overrides = {}) =>
    createTextField({
      controlId: "6",
      label: "Phone number",
      type: "tel",
      name: "mobile",
      placeholder: "0000 0000 0000",
      required: false,
      maxLength: 13,
      aria_describedby: "val6",
      ...overrides,
    }),

  organisation: (overrides = {}) =>
    createTextField({
      controlId: "5",
      label: "Organisation",
      name: "organisation",
      colSize: 4,
      placeholder: "Enter organisation",
      required: false,
      readOnly: true,
      aria_describedby: "val5",
      ...overrides,
    }),

  credentials: (overrides = {}) =>
    createTextField({
      controlId: "4",
      label: "Credentials",
      name: "credentials",
      as: "input",
      draggable: false,
      colSize: 12,
      placeholder: "Enter credentials",
      required: false,
      maxLength: 63,
      aria_describedby: "val4",
      ...overrides,
    }),
};

const commonClinicalFields = {
  study: (overrides = {}) =>
    createTextField({
      label: "Study",
      isdisabled: true,
      value: "Thrive Registry",
      name: "study",
      maxLength: 63,
      placeholder: "Study",

      ...overrides,
    }),

  testType: (overrides = {}) =>
    createTextField({
      label: "Test type",
      isdisabled: true,
      value: "Thrive Panel",
      name: "test_type",
      maxLength: 63,
      placeholder: "Test type",
      ...overrides,
    }),

  crioIdentifier: ({ isVhLogin = false, ...overrides } = {}) =>
    createTextField({
      label: getCrioLabel(isVhLogin),
      name: "crio_identifier",
      maxLength: 63,
      placeholder: overrides.isdisabled ? "Not available" : "",
      ...overrides,
    }),

  patientId: (overrides = {}) =>
    createTextField({
      label: "Participant ID",
      name: "patient_id",
      maxLength: 63,
      placeholder: "Enter details",
      isdisabled: true,
      ...overrides,
    }),
};

// ============================================
// EXPORTED FIELD CONFIGURATIONS
// ============================================

export const activationFields = {
  rows: [
    [commonPersonalFields.firstName(), commonPersonalFields.lastName()],
    [
      { ...commonPersonalFields.occupation({ isdisabled: false }) },
      commonPersonalFields.credentials(),
    ],
    [commonPersonalFields.organisation(), commonPersonalFields.mobile()],
    [
      commonPersonalFields.email(),
      createPasswordField({
        controlId: "8",
        label: "Password",
        name: "password",
        placeholder: "Create password",
        aria_describedby: "val8",
        passHints: [
          "One uppercase character",
          "One special character",
          "One number",
          "One lowercase character",
          "Minimum 8 characters",
        ],
        helpText: "",
      }),
      createButtonField({
        controlId: "9",
        name: "button",
        label: "Create Account",
        variant: "light-gray",
      }),
    ],
  ],
};

export const loginFields = [
  createEmailField({
    controlId: "1",
    label: "",
    name: "email",
    autoComplete: "username",
    placeholder: "Email address",
    aria_describedby: "val1",
  }),
  createPasswordField({
    controlId: "2",
    label: "",
    name: "password",
    autoComplete: "current-password",
    placeholder: "Password",
    aria_describedby: "val2",
    links: (
      <span className="">
        <a className="dark-blue-text" href="/forgot-password">
          Forgot your password?
        </a>
      </span>
    ),
  }),
  {
    controlId: "3",
    label: "Log in",
    type: "submit",
    className: "btn login-btn w-100",
  },
];

export const vhLoginFields = [
  createEmailField({
    controlId: "1",
    label: "Email",
    name: "email",
    autoComplete: "username",
    placeholder: "",
    aria_describedby: "val1",
    required: false,
  }),
  createPasswordField({
    controlId: "2",
    label: "Password",
    name: "password",
    autoComplete: "current-password",
    placeholder: "",
    aria_describedby: "val2",
    required: false,
    maxLength: 63,
    eyeToggleClass: "login-password",
    showToggleLabel: true,
    links: (
      <span>
        <a className="" href="/forgot-password">
          Forgot your password?
        </a>
      </span>
    ),
  }),
  {
    controlId: "3",
    label: "Sign in",
    type: "submit",
    className: "btn login-btn w-100",
  },
];

export const forgotPasswordFields = [
  createEmailField({
    controlId: "1",
    label: "Email",
    name: "email",
    placeholder: "Enter your email address",
    aria_describedby: "val1",
    links: (
      <div className="dark-grey-text">
        Know your password?{" "}
        <a className=" text-secondary" href="/login">
          Log in
        </a>
      </div>
    ),
  }),
  createSubmitButton("Reset password", {
    controlId: "3",
    size: "large",
    className: "btn m-2",
  }),
];

export const vhForgotPasswordFields = [
  createEmailField({
    controlId: "1",
    label: "Email",
    name: "email",
    placeholder: "",
    aria_describedby: "val1",
    required: false,
  }),
  createSubmitButton("Send reset link", {
    controlId: "3",
    size: "large",
    className: "btn login-btn w-100",
  }),
];

export const confirmMfaFields = [
  createTextField({
    controlId: "1",
    label: "Code",
    type: "numeric",
    helpText: "6 digit code generated by your MFS App",
    helptextClass: "text-left",
    name: "otp",
    placeholder: "Enter your auth code",
    required: true,
    aria_describedby: "val1",
  }),
  createSubmitButton("Confirm OTP", {
    controlId: "3",
    size: "large",
    className: "btn m-2",
  }),
];

export const enableMfaFields = [
  createTextField({
    controlId: "1",
    label: "Code",
    type: "numeric",
    name: "otp",
    placeholder: "Enter your auth code",
    required: true,
    aria_describedby: "val1",
    helpText: `Once you've scanned the QR code, enter the 6 digit code displayed to confirm you have the MFA stored successfully.`,
  }),
  createSubmitButton("Enable MFA", {
    controlId: "3",
    size: "large",
    className: "btn w-100",
  }),
];

export const resetPasswordFields = [
  createPasswordField({
    controlId: "1",
    label: "New password",
    name: "password",
    placeholder: "Enter you password",
    aria_describedby: "val2",
  }),
  createPasswordField({
    controlId: "2",
    label: "Confirm password",
    name: "confirmpassword",
    placeholder: "Confirm your password",
    aria_describedby: "val2",
  }),
  createSubmitButton("Reset password", {
    controlId: "3",
    size: "large",
    className: "btn m-2",
  }),
];

export const changePasswordFields = [
  createPasswordField({
    controlId: "1",
    label: "Current password",
    name: "current_password",
    placeholder: "Enter your current password",
    aria_describedby: "val2",
  }),
  createPasswordField({
    controlId: "2",
    label: "New password",
    name: "new_password",
    placeholder: "Enter your new password",
    aria_describedby: "val2",
  }),
  createPasswordField({
    controlId: "3",
    label: "Confirm password",
    name: "confirm_password",
    placeholder: "Confirm your password",
    aria_describedby: "val2",
  }),
  createSubmitButton("Change password", {
    controlId: "4",
    size: "medium",
    className: "btn mt-2",
  }),
];

export const changePasswordFieldsVH = [
  createPasswordField({
    controlId: "vh-1",
    label: "Current password ",
    name: "current_password",
    eyeToggleClass: "login-password",
    placeholder: "",
    aria_describedby: "val2",
    colSize: 6,
    required: true,
    maxLength: 63,
  }),
  createPasswordField({
    controlId: "vh-2",
    label: "New password ",
    name: "new_password",
    eyeToggleClass: "login-password",
    placeholder: "",
    aria_describedby: "val2",
    colSize: 6,
    required: true,
    maxLength: 63,
  }),
  createPasswordField({
    controlId: "vh-3",
    label: "Confirm password ",
    name: "confirm_password",
    eyeToggleClass: "login-password",
    placeholder: "",
    aria_describedby: "val2",
    colSize: 6,
    required: true,
    maxLength: 63,
  }),
  createSubmitButton("Change password", {
    controlId: "vh-4",
    size: "medium",
    className: "btn mt-2 reset-password-btn",
  }),
];

export const links = [
  {
    text: "Healthcare services",
    icon: clinicalStudiesIcon,
    alt: "Patient record icon",
    href: "/patient-record",
  },
  {
    text: "Clinical studies",
    icon: clinicalStudiesIcon,
    alt: "Clinical studies icon",
    href: "/patient-record",
  },
  {
    text: "Account",
    icon: unionIcon,
    alt: "Account icon",
    href: "/account",
  },
  {
    text: "Status viewer",
    icon: searchIcon,
    alt: "Search icon",
    href: "/search",
  },
];

export const accountFields = [
  commonPersonalFields.firstName({
    readOnly: true,
    placeholder: "Enter your first name",
  }),
  commonPersonalFields.lastName({
    readOnly: true,
    placeholder: "Enter your last name",
  }),
  {
    ...commonPersonalFields.occupation({
      type: "selectValue",
      options: OCCUPATION_OPTIONS_WITH_VALUES,
      placeholder: "Select your occupation",
      readOnly: true,
    }),
  },
  commonPersonalFields.email({
    label: "Email address",
    placeholder: "Enter your email address",
    aria_describedby: "val6",
    required: false,
  }),
  {
    ...commonPersonalFields.mobile({
      name: "phone_number_primary",
      placeholder: "0000 000 000",
      aria_describedby: "val4",
      colSize: 4,
    }),
  },
  {
    ...commonPersonalFields.organisation({
      name: "phlebotomist_org",
      placeholder: "Enter your organisation",
      aria_describedby: "val5",
      colSize: 4,
    }),
  },
  commonPersonalFields.credentials({
    readOnly: true,
    placeholder: "Enter your credentials",
    colSize: 12,
    aria_describedby: "val3",
  }),
];

export const vhAccountFields = [
  commonPersonalFields.firstName({
    readOnly: true,
    placeholder: "",
    colSize: 6,
    required: false,
  }),
  commonPersonalFields.lastName({
    readOnly: true,
    placeholder: "",
    colSize: 6,
    required: false,
  }),
  {
    ...commonPersonalFields.mobile({
      name: "phone_number_primary",
      placeholder: "",
      aria_describedby: "val4",
      colSize: 6,
    }),
  },
  commonPersonalFields.email({
    label: "Email address",
    placeholder: "",
    aria_describedby: "val6",
    required: false,
    colSize: 6,
  }),
  {
    ...commonPersonalFields.occupation({
      type: "selectValue",
      label: "Role",
      options: OCCUPATION_OPTIONS_WITH_VALUES,
      placeholder: "",
      readOnly: true,
      colSize: 6,
      required: false,
    }),
  },
  {
    ...commonPersonalFields.organisation({
      name: "phlebotomist_org",
      placeholder: "",
      aria_describedby: "val5",
      colSize: 6,
    }),
  },
];
export const patientRecordsFields = [
  createTextField({
    label: "First name",
    name: "first_name",
    maxLength: 63,
    placeholder: "First name",
  }),
  createTextField({
    label: "Last name",
    name: "last_name",
    maxLength: 63,
    placeholder: "Last name",
  }),
  createTextField({
    label: "Date of birth",
    type: "date",
    name: "dob",
    placeholder: "DD/MM/YYYY",
    className: "birth-date-field",
  }),
  createEmailField({
    label: "Email address",
    isLabel: true,
    name: "email",
    placeholder: "myname@gmail.com",
    required: false,
  }),
  createTextField({
    label: "Phone number",
    type: "tel",
    name: "phone_number_primary",
    placeholder: "0000 000 000",
    maxLength: 14,
  }),
  createTextField({
    label: "Booking ID",
    name: "booking_id",
    maxLength: 63,
    placeholder: "AB1234",
  }),
  createSubmitButton("Search", {
    name: "button",
    icon: magnifyingIcon,
    iconOrder: "On left",
    className:
      "right btn-rounded btn-lg health-care-search-btn text-transform-none",
  }),
];

export const createDOBFzield = () => ({
  type: "dobGroup",
  label: "Date of birth",
  name: "dob",
  fields: [
    {
      name: "dob_day",
      label: "Day",
      maxLength: 2,
      placeholder: "",
      required: false,
      colSize: 2,
    },
    {
      name: "dob_month",
      label: "Month",
      maxLength: 2,
      placeholder: "",
      required: false,
      colSize: 2,
    },
    {
      name: "dob_year",
      label: "Year",
      maxLength: 4,
      placeholder: "",
      required: false,
      colSize: 8,
    },
  ],
});

export const vhPatientRecordsFields = [
  createTextField({
    label: "First name",
    name: "first_name",
    maxLength: 63,
    placeholder: "",
  }),
  createTextField({
    label: "Last name",
    name: "last_name",
    maxLength: 63,
    placeholder: "",
  }),
  createDOBFzield(),
  createEmailField({
    label: "Email address",
    isLabel: true,
    name: "email",
    placeholder: "",
    required: false,
  }),
  createTextField({
    label: "Phone number",
    type: "tel",
    name: "phone_number_primary",
    placeholder: "",
    maxLength: 15,
  }),
  createTextField({
    label: "Consultation ID",
    name: "booking_id",
    maxLength: 63,
    placeholder: "",
  }),
  createSubmitButton("Search", {
    name: "button",
    icon: vhSearchIcon,
    iconOrder: "On left",
    className:
      "right btn-rounded btn-lg health-care-search-btn text-transform-none",
  }),
];

export const searchFormFields = [
  createTextField({
    label: "Patient name",
    name: "full_name",
    maxLength: 63,
    placeholder: "Enter patient name",
    isdisabled: true,
    readOnly: true,
  }),
  createTextField({
    label: "Date of birth",
    name: "dob",
    readOnly: true,
    isdisabled: true,
    placeholder: "DD/MM/YYYY",
  }),
  createEmailField({
    label: "Email address",
    name: "email",
    placeholder: "Enter your email address",
    readOnly: true,
    isdisabled: true,
    required: false,
  }),
  createTextField({
    label: "Phone number",
    type: "tel",
    name: "phone_number_primary",
    placeholder: "Enter phone number",
    readOnly: true,
    isdisabled: true,
  }),
];

export const vitalitySearchFormFields = [
  createTextField({
    label: "Full name",
    name: "full_name",
    isdisabled: true,
    readOnly: true,
  }),
  createTextField({
    label: "Date of birth",
    name: "dob",
    readOnly: true,
    isdisabled: true,
  }),
  createTextField({
    label: "Consultation ID",
    name: "booking_id",
    isdisabled: true,
    readOnly: true,
    className: "boots-bold",
  }),
  createTextField({
    label: "Phone number",
    type: "tel",
    name: "phone_number_primary",
    readOnly: true,
    isdisabled: true,
  }),
  createEmailField({
    label: "Email address",
    name: "email",
    readOnly: true,
    isdisabled: true,
    required: false,
  }),
  createTextField({
    label: "Sex at birth",
    name: "sex",
    isdisabled: true,
    readOnly: true,
  }),
  createTextField({
    label: "Ethnicity",
    name: "ethnicity",
    isdisabled: true,
    readOnly: true,
  }),
];

export const vitalityClinicalFormFields = [
  createTextField({
    label: "Full name",
    name: "full_name",
    isdisabled: true,
    readOnly: true,
  }),
  createTextField({
    label: "Date of birth",
    name: "dob",
    readOnly: true,
    isdisabled: true,
  }),
  createTextField({
    label: "Sex at birth",
    name: "sex",
    isdisabled: true,
    readOnly: true,
  }),
  createTextField({
    label: "Crio identifier (if available)",
    name: "crio_identifier",
    isdisabled: true,
    readOnly: true,
  }),
];

export const vitalitySearchFormFieldsNoDob = [
  createTextField({
    label: "Full name",
    name: "full_name",
    isdisabled: true,
    readOnly: true,
  }),
  createTextField({
    label: "Consultation ID",
    name: "booking_id",
    isdisabled: true,
    readOnly: true,
    className: "boots-bold",
  }),
  createTextField({
    label: "Phone number",
    type: "tel",
    name: "phone_number_primary",
    readOnly: true,
    isdisabled: true,
  }),
  createEmailField({
    label: "Email address",
    name: "email",
    readOnly: true,
    isdisabled: true,
    required: false,
  }),
  createTextField({
    label: "Sex at birth",
    name: "sex",
    isdisabled: true,
    readOnly: true,
  }),
  createTextField({
    label: "Ethnicity",
    name: "ethnicity",
    isdisabled: true,
    readOnly: true,
  }),
];

export const vhAppointmentConfirmationFields = [
  { label: "Participant name", name: "full_name" },
  { label: "Date of birth", name: "dob" },
  { label: "Participant ID", name: "patient_id", className:"boots-bold"},
  { label: "Test type", name: "test_type" },
  { label: "SST barcode", name: "primary_barcode", editType: "barcode" },
  { label: "EDTA barcode", name: "secondary_barcode", editType: "barcode" },
  { label: "Date of sample collection", name: "sample_collection_date", editType: "date" },
  { label: "Time of sample collection", name: "sample_collection_time", editType: "time" },
  {
    label: "Number of blood draw attempts",
    name: "number_of_attempts",
    editType: "attempts",
  },
];

const createConfirmationBaseFields = () => [
  createTextField({
    label: "Test type",
    name: "test_type",
    placeholder: "",
    readOnly: true,
    isdisabled: true,
  }),
  createTextField({
    label: "Vessel type",
    name: "vessel_info_1",
    className: "",
    placeholder: "",
    readOnly: true,
    isdisabled: true,
  }),
];

export const ConfirmationOneTubeFields = [
  ...searchFormFields,
  ...createConfirmationBaseFields(),
  createTextField({
    label: "Repeated test",
    type: "boolean",
    name: "repeated_test",
    placeholder: "",
    readOnly: true,
    isdisabled: true,
  }),
  createTextField({
    label: "Location store",
    type: "dropdown",
    name: "location_store",
    placeholder: "Please choose store location",
    className: "location-dropdown form-group",
  }),
];

export const ConfirmationTwoTubeFields = [
  ...searchFormFields,
  createTextField({
    label: "Test type",
    placeholder: "Test type",
    isdisabled: true,
    name: "test_type",
  }),
  createTextField({
    label: "Vessel type 1",
    placeholder: "Vessel type",
    name: "vessel_info_1",
    isdisabled: true,
    className: "",
    readOnly: true,
  }),
  createTextField({
    label: "Vessel type 2",
    className: "",
    placeholder: "Vessel type",
    isdisabled: true,
    name: "vessel_info_2",
    readOnly: true,
  }),
  createTextField({
    label: "Repeated test",
    type: "boolean",
    placeholder: "",
    isdisabled: true,
    name: "repeated_test",
    readOnly: true,
  }),
  createTextField({
    label: "Location store",
    type: "dropdown",
    name: "location_store",
    placeholder: "Please choose store location",
  }),
];

const createBarcodeCommonFields = () => [
  createDateField({ colSize: 4 }),
  createTimeField({ colSize: 4 }),
  createAttemptsField({ colSize: 4, hrAfter: true }),
  createNotesField({
    colSize: 12,
    label: "Notes",
    placeholder: "Enter details",
  }),
];

const createBarcodeButtons = () =>
  createButtonGroup([
    createButtonField({
      label: "Reject",
      variant: "danger",
      name: "button",
      className: "semi-buttons",
      size: "small",
    }),
    createButtonField({
      label: "Back",
      variant: "outline",
      name: "back",
      className: "semi-buttons",
      size: "small",
    }),
    createSubmitButton("Save & continue", {
      variant: "secondary",
      name: "button",
      className: "semi-buttons",
      size: "small",
    }),
  ]);

export const BarcodeOneTubeFields = [
  createTextField({
    label: "Test type",
    name: "test_type",
    readOnly: true,
    colSize: 12,
    className: "test-type-field form-group",
    isdisabled: true,
  }),
  createBarcodeField({
    name: "primary_barcode",
    placeholder: "PGK-xxx-1234",
    image: barcodeImage,
    helpTextAbove: `<span class="serial-no">1. </span><span class="underline-text"><span class="danger-text">Before</span> drawing blood,</span> enter the kit barcode number <span class='my-2 py-1 d-flex barcode-grey-text'>Please enter the 10-character SST (GOLD) barcode for the specific test type.</span>`,
    overrides: {
      colSize: 8,
      hrAfter: true,
      textAfter: true,
      required: true,
    },
  }),
  ...createBarcodeCommonFields(),
];

export const BarcodeTwoTubeFields = [
  createTextField({
    label: "Test type",
    name: "test_type",
    placeholder: "Enter Test type",
    readOnly: true,
    className: "test-type-field form-group",
    colSize: 12,
    isdisabled: true,
  }),
  {
    label: "",
    type: "barcode-text",
    helpTextAbove: `<span class="serial-no">1. </span><span class="underline-text"><span class="danger-text">Before</span> drawing blood,</span> enter the kit barcode number`,
    FormFieldImage: barcodeImage,
    colSize: 12,
  },
  createBarcodeField({
    name: "primary_barcode",
    placeholder: "PGK-abc-1234",
    image: barcodeImage,
    helpTextAbove:
      "<p class='my-2 py-1 d-flex barcode-grey-text'>Please enter the 10-character SST (GOLD)<br> barcode for the specific test type</p>",
    overrides: {
      colSize: 6,
    },
  }),
  createBarcodeField({
    name: "secondary_barcode",
    placeholder: "PLK-abc-1234",
    image: barcodeLavenderImage,
    helpTextAbove:
      "<p class='my-2 py-1 d-flex barcode-grey-text'>Please check the 10-character EDTA<br> (LAVENDER) barcode for the specific test type</p>",
    overrides: {
      colSize: 6,
      readOnly: true,
      hrAfter: true,
      textAfter: true,
      isdisabled: true,
    },
  }),
  createDateField({ colSize: 4 }),
  createTimeField({ colSize: 4 }),
  createAttemptsField({ colSize: 4, hrAfter: true }),
  createNotesField({
    colSize: 12,
    label: "Notes",
    placeholder: "Enter details",
  }),
];

export const ClinicalBarcodeFields = [
  createTextField({
    label: "Test type",
    name: "test_type",
    placeholder: "Enter Test type",
    readOnly: true,
    className: "test-type-field form-group",
    colSize: 12,
    required: false,
    isdisabled: true,
  }),
  {
    label: "",
    type: "barcode-text",
    helpTextAbove: `<span class="serial-no">1. </span><span class="underline-text"><span class="danger-text">Before</span> drawing blood,</span> enter the kit barcode number`,
    FormFieldImage: barcodeImage,
    colSize: 12,
  },
  createBarcodeField({
    name: "primary_barcode",
    placeholder: "PGK-abc-1234",
    image: barcodeImage,
    helpTextAbove:
      "<p class='my-2 py-1 d-flex barcode-grey-text'>Please enter the 10-character SST (GOLD)<br>  barcode for the specific test type</p>",
    overrides: {
      colSize: 6,
    },
  }),
  createBarcodeField({
    name: "secondary_barcode",
    placeholder: "PLK-abc-1234",
    image: barcodeLavenderImage,
    helpTextAbove:
      "<p class='my-2 py-1 d-flex barcode-grey-text'>Please check the 10-character EDTA<br> (LAVENDER) barcode for the specific test type</p>",
    overrides: {
      colSize: 6,
      readOnly: true,
      hrAfter: true,
      textAfter: true,
      disabled: true,
      isdisabled: true,
    },
  }),
  createDateField({ colSize: 4 }),
  createTimeField({ colSize: 4 }),
  createAttemptsField({ colSize: 4, hrAfter: false }),
  createNotesField({
    label: "Notes",
    placeholder: "Enter details",
    colSize: 12,
  }),
];

export const testKitRegistrationFields = [
  createNotesField({
    label: "Notes",
    placeholder: "Enter details",
    type: "text-area",
    className: "notes-textarea px-3",
    colSize: 12,
    readOnly: true,
  }),
];

const createRejectionFields = (label, options) => [
  createSelectField(options, {
    label,
    name: "rejection_reason",
    placeholder: "Choose reason",
    colSize: 5,
    hrAfter: true,
    className: "rejection-select",
  }),
  createTextField({
    label: "",
    placeholder: "Notes",
    as: "textarea",
    name: "notes",
    maxLength: 256,
    className: "notes-textarea",
    required: true,
    colSize: 5,
  }),
  createButtonGroup([
    createSubmitButton("Reject", {
      variant: "danger",
      name: "button",
      className: "ms-auto btn-rounded",
      size: "small",
      colSize: 2,
    }),
    createButtonField({
      label: "Cancel",
      variant: "secondary",
      name: "button",
      size: "small",
      colSize: 2,
      className: "btn-rounded",
    }),
  ]),
];

export const testKitRejectionFields = createRejectionFields(
  "Select reason for kit rejection",
  ["Barcode(s) wasted", "Kit expired", "Missing components", "Other(s)"],
);

export const testApptRejectionFields = createRejectionFields(
  "Select reason for appointment rejection",
  [
    "Fainters",
    "Feeling faint",
    "Adverse reaction",
    "Needle stick injuries",
    "Other(s)",
  ],
);

export const vhKitRejectionReasons = [
  { value: "barcode-damaged", label: "Barcode(s) damaged or unusable" },
  { value: "kit-expired", label: "Kit expired" },
  { value: "missing", label: "Missing components" },
  { value: "kit-other", label: "Other reason (please add notes)" },
];

export const vhAppointmentRejectionReasons = [
  { value: "consent-declined", label: "Consent declined or withdrawn" },
  { value: "failed-venepuncture", label: "Failed venepuncture" },
  { value: "fainters-faint", label: "Fainters/Feeling faint" },
  {
    value: "adverse-reaction",
    label: "Adverse reaction (record type of reaction in notes)",
  },
  { value: "appointment-other", label: "Other Reason (please add notes)" },
];

const createClinicalBaseFields = (disabled = false, required = false) => [
  commonClinicalFields.study({ required: false }),
  commonClinicalFields.testType({ required: false }),
  createTextField({
    label: "First name",
    name: "first_name",
    maxLength: 63,
    placeholder: "First name",
    isdisabled: disabled,
    required: required,
  }),
  createTextField({
    label: "Last name",
    name: "last_name",
    maxLength: 63,
    placeholder: "Last name",
    isdisabled: disabled,
    required: required,
  }),
];

export const clinicalStudiesFields = [
  ...createClinicalBaseFields(false, true),
  createTextField({
    label: "Date of birth",
    type: "date",
    name: "date_of_birth",
    maxLength: 63,
    placeholder: "DD/MM/YYYY",
    required: true,
  }),
  createSelectField(["Male", "Female"], {
    label: "Sex at birth",
    name: "sex_at_birth",
    maxLength: 63,
    placeholder: "Select sex at birth",
    required: true,
  }),
  commonClinicalFields.crioIdentifier(),
  createSubmitButton("Search", {
    name: "button",
    icon: magnifyingIcon,
    iconOrder: "On left",
    className: "w-100 btn-rounded",
  }),
];

export const vhClinicalStudiesFields = [
  ...createClinicalBaseFields(false, true).map((field) =>
    ["first_name", "last_name"].includes(field.name)
      ? { ...field, placeholder: "", required: false }
      : field,
  ),
  createDOBFzield(),
  createSelectField(["Male", "Female"], {
    label: "Sex at birth",
    name: "sex_at_birth",
    required: false,
    maxLength: 63,
    placeholder: "Select sex at birth",
  }),
  commonClinicalFields.crioIdentifier({ isVhLogin: true }),
  createSubmitButton("Search", {
    name: "button",
    icon: vhSearchIcon,
    iconOrder: "On left",
    className: "w-100 btn-rounded",
  }),
];

export const clinicalPatientFields = [
  ...createClinicalBaseFields(true),
  createTextField({
    label: "Date of birth",
    name: "date_of_birth",
    maxLength: 63,
    placeholder: "DD/MM/YYYY",
    isdisabled: true,
  }),
  createTextField({
    label: "Sex at birth",
    name: "sex_at_birth",
    maxLength: 63,
    placeholder: "Select gender",
    isdisabled: true,
  }),
  commonClinicalFields.crioIdentifier({ isdisabled: true }),
  commonClinicalFields.patientId(),
];

export const SelectedPatientFields = [
  ...clinicalPatientFields,
  createSubmitButton("Select participant", {
    name: "button",
    className: "w-100 right btn-rounded my-4",
  }),
];

export const clinicalPatientConfirmationFields = [
  commonClinicalFields.study({ colSize: 4 }),
  commonClinicalFields.testType({ colSize: 4 }),
  createTextField({
    label: "First name",
    name: "first_name",
    maxLength: 63,
    placeholder: "First name",
    isdisabled: true,
    colSize: 4,
  }),
  createTextField({
    label: "Last name",
    name: "last_name",
    maxLength: 63,
    placeholder: "Last name",
    isdisabled: true,
    colSize: 4,
  }),
  createTextField({
    label: "Date of birth",
    name: "dob",
    maxLength: 63,
    placeholder: "DD/MM/YYYY",
    isdisabled: true,
    colSize: 4,
  }),
  createTextField({
    label: "Sex at birth",
    name: "sex",
    maxLength: 63,
    placeholder: "Select gender",
    isdisabled: true,
    colSize: 4,
  }),
  commonClinicalFields.crioIdentifier({ isdisabled: true, colSize: 4 }),
  commonClinicalFields.patientId({ colSize: 4 }),
  createTextField({
    label: "Repeated test",
    name: "repeated_test",
    maxLength: 63,
    placeholder: "Enter details",
    isdisabled: true,
    colSize: 4,
  }),
  createTextField({
    label: "Vessel type",
    as: "textarea",
    name: "vessel_type",
    maxLength: 63,
    placeholder: "Enter details",
    isdisabled: true,
    colSize: 4,
    className: "vessel-textarea",
  }),
  createTextField({
    label: "Location store",
    type: "dropdown",
    name: "location_store",
    placeholder: "Please choose store location",
    className: "location-dropdown form-group",
    disabled: false,
    colSize: 4,
  }),
];
//region Vitality Healthchecks fields

const renderValidatedInput =
  (name, min, max, opts = {}) =>
  (value, row, onFieldChange, error) => {
    const isClinicalReading = row.reading === "Clinical reading";
    return (
      <div className="vh-input-wrapper">
        <input
          type="text"
          inputMode="decimal"
          pattern="[0-9]*"
          placeholder={isClinicalReading ? "Value" : opts.placeholder || ""}
          value={value || ""}
          min={min}
          max={max}
          step={opts.step || "any"}
          disabled={opts.disabled}
          readOnly={opts.readOnly}
          onChange={(e) => {
            let numericValue = e.target.value.replace(/[^0-9.]/g, "");
            const parts = numericValue.split(".");
            parts[0] = parts[0].slice(0, 3);

            if (parts.length > 1) {
              parts[1] = parts[1].slice(0, 2);
            }

            numericValue =
              parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];

            onFieldChange(row.id, name, numericValue);
          }}
          className={error ? "vh-input-error" : ""}
        />
      </div>
    );
  };

export const bodyMeasurementsColumns = [
  {
    dataField: "parameter",
    text: "Parameters",
  },
  {
    dataField: "height",
    text: (
      <>
        Height
        <span>cm</span>
      </>
    ),
    render: renderValidatedInput("height", undefined, undefined, {
      placeholder: "Value",
    }),
  },
  {
    dataField: "weight",
    text: (
      <>
        Weight
        <span>kg</span>
      </>
    ),
    render: renderValidatedInput("weight", undefined, undefined, {
      placeholder: "Value",
    }),
  },
  {
    dataField: "bmi",
    text: "BMI",
    min: 10,
    max: 70,
    render: renderValidatedInput("bmi", 10, 70, {
      disabled: true,
      readOnly: true,
      placeholder: "Value",
    }),
  },
  {
    dataField: "waist",
    text: (
      <>
        Waist circumference
        <span>cm</span>
      </>
    ),
    min: 30,
    max: 200,
    render: renderValidatedInput("waist", 30, 200, { placeholder: "Value" }),
  },
  {
    dataField: "waistRatio",
    text: "Waist: Height Ratio",
    render: renderValidatedInput("waistRatio", undefined, undefined, {
      disabled: true,
      readOnly: true,
      placeholder: "Value",
    }),
  },
];

export const bloodPressureColumns = [
  {
    dataField: "reading",
    text: "Reading",
    render: (value) => {
      if (typeof value === "string" && value.includes("(if necessary)")) {
        const parts = value.split("(if necessary)");
        return (
          <span>
            {parts[0]}
            <span className="boots-light" style={{ fontSize: "14px" }}>
              (if necessary)
            </span>
            {parts[1]}
          </span>
        );
      }
      return value;
    },
  },
  {
    dataField: "systolic",
    text: (
      <>
        Systolic
        <span>mmHg</span>
      </>
    ),
    min: 40,
    max: 300,
    render: renderValidatedInput("systolic", 40, 300, { placeholder: "Value" }),
  },
  {
    dataField: "diastolic",
    text: (
      <>
        Diastolic
        <span>mmHg</span>
      </>
    ),
    min: 30,
    max: 200,
    render: renderValidatedInput("diastolic", 20, 300, {
      placeholder: "Value",
    }),
  },
  {
    dataField: "heartRate",
    text: (
      <>
        Heart rate
        <span>bpm</span>
      </>
    ),
    render: renderValidatedInput("heartRate", undefined, undefined, {
      placeholder: "Value",
    }),
  },
  {
    dataField: "armUsed",
    text: "Arm used",
    render: (value, row, onFieldChange) => {
      return (
        <div className="select-wrapper">
          <select
            value={value || ""}
            onChange={(e) => onFieldChange(row.id, "armUsed", e.target.value)}
          >
            <>
              <option value="">Select an arm?</option>
              <option value="Left arm">Left arm</option>
              <option value="Right arm">Right arm</option>
            </>
          </select>
        </div>
      );
    },
  },
];

export const lipidProfileColumns = [
  {
    dataField: "totalCholesterol",
    text: (
      <>
        Total Cholesterol
        <span>mmol/L</span>
      </>
    ),
    min: 0.1,
    max: 12,
    render: renderValidatedInput("totalCholesterol", 0.1, 12, {
      placeholder: "Value",
    }),
  },
  {
    dataField: "hdlCholesterol",
    text: (
      <>
        HDL Cholesterol
        <span>mmol/L</span>
      </>
    ),
    min: 0.1,
    max: 10,
    render: renderValidatedInput("hdlCholesterol", 0.1, 10, {
      placeholder: "Value",
    }),
  },
  {
    dataField: "triglycerides",
    text: (
      <>
        Triglycerides
        <span>mmol/L</span>
      </>
    ),
    min: 0.1,
    max: 10,
    render: renderValidatedInput("triglycerides", 0.1, 10, {
      placeholder: "Value",
    }),
  },
  {
    dataField: "ldlCholesterol",
    text: (
      <>
        LDL Cholesterol
        <span>mmol/L</span>
      </>
    ),
    min: 0.1,
    max: 10,
    render: renderValidatedInput("ldlCholesterol", 0.1, 10, {
      disabled: true,
      readOnly: true,
      placeholder: "Value",
    }),
  },
  {
    dataField: "totalHdlRatio",
    text: "TC:HDL Ratio",
    min: 1,
    max: 16,
    render: renderValidatedInput("totalHdlRatio", 1, 16, {
      disabled: true,
      readOnly: true,
      placeholder: "Value",
    }),
  },
  {
    dataField: "nonHdlCholesterol",
    text: (
      <>
        Non-HDL Cholesterol
        <span>mmol/L</span>
      </>
    ),
    min: 0.1,
    max: 10,
    render: renderValidatedInput("nonHdlCholesterol", 0.1, 10, {
      disabled: true,
      readOnly: true,
      placeholder: "Value",
    }),
  },
  {
    dataField: "heartAge",
    text: (
      <>
        Heart age
        <span>years</span>
      </>
    ),
    min: 18,
    max: 100,
    render: renderValidatedInput("heartAge", 18, 100, { placeholder: "Value" }),
  },
  {
    dataField: "cvdRisk",
    text: (
      <>
        10-year-
        <br />
        CVD risk
        <span>%</span>
      </>
    ),
    min: 0,
    max: 100,
    render: renderValidatedInput("cvdRisk", 0, 100, { placeholder: "Value" }),
  },
];

export const glucoseColumns = [
  {
    dataField: "parameter",
    text: "Parameters",
  },
  {
    dataField: "glucose",
    text: (
      <>
        Glucose
        <span>mmol/L</span>
      </>
    ),
    min: 0.1,
    max: 40,
    render: renderValidatedInput("glucose", 0.1, 40, { placeholder: "Value" }),
  },
];

//endregion

// ========================================
// CLINICAL SCREENING FIELDS
// ========================================

export const SCREENING_FIELD_NAMES = {
  FEELS_UNWELL: "feels_unwell",
  PREGNANT_OR_GIVEN_BIRTH: "pregnant_or_given_birth",
};

const createScreeningRadioItem = (name, label, overrides = {}) => ({
  name,
  label,
  options: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  required: true,
  ...overrides,
});

const createScreeningCheckboxItem = (name, label, overrides = {}) => ({
  name,
  label,
  ...overrides,
});

export const vitalityDefaultScreeningQuestions = [
  createScreeningRadioItem(
    SCREENING_FIELD_NAMES.FEELS_UNWELL,
    "Do you feel unwell or have a high temperature today?",
  ),
  createScreeningRadioItem(
    SCREENING_FIELD_NAMES.PREGNANT_OR_GIVEN_BIRTH,
    "Are you pregnant or have you given birth within the last 3 months?",
  ),
];

const vitalityScreeningQuestions = [
  createScreeningRadioItem("is_smoker", "Are you a smoker?"),
  createScreeningRadioItem(
    "diagnosis_cvd_bp_cholesterol_diabetes",
    "Do you have a diagnosis of cardiovascular disease, high blood pressure, high cholesterol, or diabetes?",
  ),
  createScreeningRadioItem(
    "diabetes_symptoms",
    "Do you have any of the following symptoms: increased thirst, frequent urination, tiredness or blurred vision?",
  ),
  createScreeningRadioItem(
    "eaten_or_drunk_last_2_hours",
    "Have you eaten or had anything other than water in the last 2 hours?",
  ),
  createScreeningRadioItem(
    "allergy_plasters_tape_gauze_latex_dressings",
    "Do you have any allergy or skin reaction to plasters, tape, gauze, latex, or dressings?",
  ),
  createScreeningRadioItem(
    "bleeding_disorder_or_anticoagulant",
    "Do you have a bleeding disorder or take any anticoagulant medication or injections?",
  ),
];

const heartScreeningQuestions = [
  createScreeningRadioItem("is_smoker", "Are you a smoker?"),
  createScreeningRadioItem(
    "diagnosis_cvd_bp_cholesterol_diabetes",
    "Do you have a diagnosis of cardiovascular disease, high blood pressure, high cholesterol, or diabetes?",
  ),
  createScreeningRadioItem(
    "allergy_plasters_tape_gauze_latex_dressings",
    "Do you have any allergy or skin reaction to plasters, tape, gauze, latex, or dressings?",
  ),
  createScreeningRadioItem(
    "bleeding_disorder_or_anticoagulant",
    "Do you have a bleeding disorder or take any anticoagulant medication or injections?",
  ),
];

export const SCREENING_QUESTIONS_BY_SERVICE = {
  vitality: vitalityScreeningQuestions,
  "heart-health-check": heartScreeningQuestions,
};

export const DEFAULT_SCREENING_SERVICE = "vitality";

export const getScreeningQuestions = (serviceName) =>
  SCREENING_QUESTIONS_BY_SERVICE[serviceName] ||
  SCREENING_QUESTIONS_BY_SERVICE[DEFAULT_SCREENING_SERVICE];

export const advicePrompts = (serviceCost) => [
  createScreeningCheckboxItem(
    "advice_measurements_included",
    "Health Check includes measuring your blood pressure, height, weight, as well as a small finger-prick blood test to check your cholesterol and blood sugar levels",
  ),
  createScreeningCheckboxItem(
    "advice_screening_not_diagnostic",
    "Health Check is a screening tool, not a diagnostic test. It can help identify potential risk factors or results that may need further investigation, but it cannot confirm a medical condition. If any results are outside the expected range, you may be advised to follow up with your GP or another healthcare professional",
  ),
  createScreeningCheckboxItem(
    "advice_results_may_be_influenced",
    "Results maybe influenced by some underlying conditions or medications",
  ),
  createScreeningCheckboxItem(
    "advice_reference_ranges",
    "Reference ranges used in this Health Check are based on recognised clinical guidance and may differ from the thresholds used by Vitality to award programme points",
  ),
  createScreeningCheckboxItem(
    "advice_cost_of_service",
    `Aware of cost of service (${formatCost(serviceCost)})`,
  ),
];

const heartAdvicePrompts = () => [
  createScreeningCheckboxItem(
    "advice_measurements_included",
    "Health Check includes measuring your blood pressure, height, weight, as well as a small finger-prick blood test to check your cholesterol and blood sugar levels",
  ),
  createScreeningCheckboxItem(
    "advice_screening_not_diagnostic",
    "Health Check is a screening tool, not a diagnostic test. It can help identify potential risk factors or results that may need further investigation, but it cannot confirm a medical condition. If any results are outside the expected range, you may be advised to follow up with your GP or another healthcare professional",
  ),
  createScreeningCheckboxItem(
    "advice_results_may_be_influenced",
    "Results maybe influenced by some underlying conditions or medications",
  ),
];

export const ADVICE_PROMPTS_BY_SERVICE = {
  "vitality-healthcheck": advicePrompts,
  "heart-health-check": heartAdvicePrompts,
};

export const DEFAULT_ADVICE_SERVICE = "vitality-healthcheck";

export const getAdvicePrompts = (serviceName, serviceCost) => {
  const getPrompts =
    ADVICE_PROMPTS_BY_SERVICE[serviceName] ||
    ADVICE_PROMPTS_BY_SERVICE[DEFAULT_ADVICE_SERVICE];

  return getPrompts(serviceCost);
};

export const patientConsent = [
  createScreeningCheckboxItem(
    "consent_to_data_sharing",
    "Patient consents to sharing their data with Vitality (optional)",
    { required: false },
  ),
  createScreeningCheckboxItem(
    "patient_happy_to_proceed",
    "Patient confirms they are happy to proceed based on the information provided (mandatory)",
  ),
];

const heartPatientConsent = [
  createScreeningCheckboxItem(
    "patient_happy_to_proceed",
    "Patient is happy to proceed based on information provided and has no further questions (mandatory)",
  ),
];

export const PATIENT_CONSENT_BY_SERVICE = {
  "vitality-healthcheck": patientConsent,
  "heart-health-check": heartPatientConsent,
};

export const DEFAULT_CONSENT_SERVICE = "vitality-healthcheck";

export const getPatientConsent = (serviceName) =>
  PATIENT_CONSENT_BY_SERVICE[serviceName] ||
  PATIENT_CONSENT_BY_SERVICE[DEFAULT_CONSENT_SERVICE];

export const SCREENING_DISABLE_TRIGGER_FIELDS = {
  vitality: [
    SCREENING_FIELD_NAMES.FEELS_UNWELL,
    SCREENING_FIELD_NAMES.PREGNANT_OR_GIVEN_BIRTH,
  ],
};

export const getDisableTriggerFields = (serviceName) =>
  SCREENING_DISABLE_TRIGGER_FIELDS[serviceName] ||
  SCREENING_DISABLE_TRIGGER_FIELDS[DEFAULT_SCREENING_SERVICE];

export const MEASUREMENT_SECTIONS = {
  BODY_MEASUREMENTS: "body_measurements",
  BLOOD_PRESSURE: "blood_pressure",
  LIPID_PROFILE: "lipid_profile",
  GLUCOSE: "glucose",
};

const ALL_SECTIONS = Object.values(MEASUREMENT_SECTIONS);

const SERVICE_SECTION_MAP = {
  "vitality-healthcheck": ALL_SECTIONS,
  "heart-health-check": [
    MEASUREMENT_SECTIONS.BODY_MEASUREMENTS,
    MEASUREMENT_SECTIONS.BLOOD_PRESSURE,
    MEASUREMENT_SECTIONS.LIPID_PROFILE,
  ],
};

export const getEnabledSections = (serviceName) =>
  SERVICE_SECTION_MAP[serviceName] ?? ALL_SECTIONS;

const VH_SST_TEXT =
  "1A. Before drawing blood, scan or manually enter the 10-character SST (GOLD top) blood collection vessel barcode.";
const VH_EDTA_TEXT =
  "1B. Confirm the EDTA (LAVENDER) blood collection vessel barcode.";
const VH_SEARCH_PLACEHOLDER = "Search products, brands and services...";

const vhTestTypeField = () =>
  createTextField({
    label: "Test type",
    name: "test_type",
    readOnly: true,
    colSize: 6,
    className: "test-type-field form-group",
    isdisabled: true,
  });

const vhAttemptsField = () => [
  {
    label: "3. Select number of draw attempts",
    type: "radioGroup",
    name: "number_of_attempt",
    options: [
      { label: "1", value: "1" },
      { label: "2", value: "2" },
    ],
    colSize: 4,
  },
  {
    label: "4. Date of sample collection",
    type: "dateGroup",
    name: "sample_collection_date",
    colSize: 4,
  },
  {
    label: "5. Time of sample collection",
    type: "timeGroup",
    name: "sample_collection_time",
    colSize: 4,
  },
];

export const VhBarcodeOneTubeFields = [
  vhTestTypeField(),
  createBarcodeField({
    name: "primary_barcode",
    placeholder: "PGW-ZAC-9024",
    image: vhBarcodeImage,
    helpTextAbove:
      "1. Before drawing blood, scan or manually enter the SST (GOLD top) blood collection vessel barcode.",
    overrides: {
      colSize: 12,
      required: true,
      hrAfter: true,
      textAfter: true,
    },
  }),
  ...vhAttemptsField(),
];

export const VhBarcodeTwoTubeFields = [
  vhTestTypeField(),
  createBarcodeField({
    name: "primary_barcode",
    placeholder: "PGW-ZAC-9024",
    image: vhBarcodeImage,
    helpTextAbove: VH_SST_TEXT,
    overrides: { colSize: 6, required: true },
  }),
  createBarcodeField({
    name: "secondary_barcode",
    placeholder: "PLG-DEX-3015",
    image: vhBarcodeLavenderImage,
    helpTextAbove: VH_EDTA_TEXT,
    overrides: {
      colSize: 6,
      readOnly: true,
      isdisabled: true,
      hrAfter: true,
      textAfter: true,
    },
  }),
  ...vhAttemptsField(),
];

export const VhClinicalBarcodeFields = [
  commonClinicalFields.study({
    colSize: 6,
    className: "study-field form-group",
    isdisabled: true,
  }),
  commonClinicalFields.testType({
    colSize: 6,
    className: "test-type-field form-group",
    isdisabled: true,
  }),
  createBarcodeField({
    name: "primary_barcode",
    placeholder: "PGW-ZAC-9024",
    image: vhBarcodeImage,
    helpTextAbove: VH_SST_TEXT,
    overrides: { colSize: 6, required: true },
  }),
  createBarcodeField({
    name: "secondary_barcode",
    placeholder: "PLG-DEX-3015",
    image: vhBarcodeLavenderImage,
    helpTextAbove: VH_EDTA_TEXT,
    overrides: {
      colSize: 6,
      readOnly: true,
      isdisabled: true,
      hrAfter: true,
      textAfter: true,
    },
  }),
  ...vhAttemptsField(),
];

const vhCreateConfirmationBaseFields = () => [
  { label: "Patient name", name: "full_name" },
  { label: "Date of birth", name: "dob" },
  { label: "Consultation ID", name: "booking_id", className: "boots-bold" },
  { label: "Test type", name: "test_type" },
  { label: "SST barcode", name: "primary_barcode", editType: "barcode" },
];

export const vhConfirmationOneTubeFields = [
  ...vhCreateConfirmationBaseFields(),
  {
    label: "Date of sample collection",
    name: "sample_collection_date",
    editType: "date",
  },
  {
    label: "Time of sample collection",
    name: "sample_collection_time",
    editType: "time",
  },
  {
    label: "Number of blood draw attempts",
    name: "number_of_attempts",
    editType: "attempts",
  },
];

export const vhConfirmationTwoTubeFields = [
  ...vhCreateConfirmationBaseFields(),
  { label: "EDTA barcode", name: "secondary_barcode", editType: "barcode" },
  {
    label: "Date of sample collection",
    name: "sample_collection_date",
    editType: "date",
  },
  {
    label: "Time of sample collection",
    name: "sample_collection_time",
    editType: "time",
  },
  {
    label: "Number of blood draw attempts",
    name: "number_of_attempts",
    editType: "attempts",
  },
];
